import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {GrastUser} from "../data-structures/GrastUser";

interface AuthState {
    client: GrastUser,
    isAuthed: boolean
}

const initialState: AuthState = {
    client: {
        name: '',
        groups: [],
        accessToken: ''
    },
    isAuthed: false
};

const projectSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        userAuthed: (state, action: PayloadAction<GrastUser>) => {
            state.client = action.payload;
            state.isAuthed = true;
        }
    }
});

const authActions = projectSlice.actions;
const authReducer = projectSlice.reducer;
export {
    authActions
}

export default authReducer;
